const GlobeGridIcon = () => {
    return (

<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="17.7005" cy="17.64" r="14.5833" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<ellipse cx="17.6999" cy="17.64" rx="7.29167" ry="14.5833" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M30.0964 10.3486L5.30469 10.3486" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
<path d="M30.0964 24.9316H5.30469" stroke="#0C0C0C" strokeWidth="1.5" strokeLinejoin="round"/>
</svg>


    )
}



export default GlobeGridIcon